/**
 * @generated SignedSource<<a03ec1a9484c98ba4ce1b2706cf000ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProblemDifficultyLevelEnum = "high" | "highest" | "low" | "lowest" | "medium" | "%future added value";
export type BookScrapUpdateInput = {
  difficultyLevel?: ProblemDifficultyLevelEnum | null;
  id: string;
  problemBookPage?: number | null;
  problemNumber?: string | null;
  problemTex?: string | null;
  solutionBookPage?: number | null;
  solutionTex?: string | null;
  unitD?: string | null;
};
export type BookScrapUpdateDialog_bookScrapUpdateMutation$variables = {
  input: BookScrapUpdateInput;
};
export type BookScrapUpdateDialog_bookScrapUpdateMutation$data = {
  readonly bookScrapUpdate: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"BookScrapUpdateDialog_bookScrap">;
  };
};
export type BookScrapUpdateDialog_bookScrapUpdateMutation = {
  response: BookScrapUpdateDialog_bookScrapUpdateMutation$data;
  variables: BookScrapUpdateDialog_bookScrapUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BookScrapUpdateDialog_bookScrapUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BookScrap",
        "kind": "LinkedField",
        "name": "bookScrapUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BookScrapUpdateDialog_bookScrap"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BookScrapUpdateDialog_bookScrapUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BookScrap",
        "kind": "LinkedField",
        "name": "bookScrapUpdate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UnitD",
            "kind": "LinkedField",
            "name": "unitD",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "difficultyLevel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "problemBookPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "problemNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "problemTex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "solutionBookPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "solutionTex",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "03a12175a7f647576e06c151f4db27ef",
    "id": null,
    "metadata": {},
    "name": "BookScrapUpdateDialog_bookScrapUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation BookScrapUpdateDialog_bookScrapUpdateMutation(\n  $input: BookScrapUpdateInput!\n) {\n  bookScrapUpdate(input: $input) {\n    id\n    ...BookScrapUpdateDialog_bookScrap\n  }\n}\n\nfragment BookScrapUpdateDialog_bookScrap on BookScrap {\n  id\n  unitD {\n    id\n  }\n  difficultyLevel\n  problemBookPage\n  problemNumber\n  problemTex\n  solutionBookPage\n  solutionTex\n}\n"
  }
};
})();

(node as any).hash = "bae1920c1c2e5e6cad9c2b27f0247ef1";

export default node;
